module.exports = __webpack_public_path__ + "color-blur.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/color-blur.jpg
// module id = 878
// module chunks = 0